import React, { createContext, useContext, useState, useEffect } from 'react';
import { getData } from '../services/api';

const TenantContext = createContext(null);

export const useTenant = () => {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error('useTenant must be used inside TenantProvider');
  return ctx;
};

export const TenantProvider = ({ children }) => {
  const [tenantSettings, setTenantSettings] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadTenantSettings = async () => {
    const tenantId = localStorage.getItem('tenantId');
    if (!tenantId) return;
    try {
      setLoading(true);
      const data = await getData('/settings');
      if (data.success) {
        setTenantSettings(data.data);
        // Apply branding CSS variables
        if (data.data?.branding?.primaryColor) {
          const color = data.data.branding.primaryColor;
          document.documentElement.style.setProperty('--tenant-primary', color);
          // Convert hex to RGB for rgba usage
          const r = parseInt(color.slice(1,3), 16);
          const g = parseInt(color.slice(3,5), 16);
          const b = parseInt(color.slice(5,7), 16);
          document.documentElement.style.setProperty('--tenant-primary-rgb', `${r},${g},${b}`);
        }
      }
    } catch (e) {
      // silently fail
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    const tenantId = localStorage.getItem('tenantId');
    if (token && tenantId) {
      loadTenantSettings();
    }
  }, []);

  return (
    <TenantContext.Provider value={{ tenantSettings, loading, loadTenantSettings }}>
      {children}
    </TenantContext.Provider>
  );
};
